import { useCallback, useMemo, useState } from 'react';

import { TimeCard } from '@work4all/models/lib/Classes/TimeCard.entity';
import { WorkingTimeTimeCardDayInfo } from '@work4all/models/lib/Classes/WorkingTimeTimeCardDayInfo.entity';

export const useTimePreview = (
  timeCard: TimeCard,
  refetch: () => Promise<void>
) => {
  const [selectedDate, setSelectedDate] = useState<string>(undefined);

  const showDetails = useCallback((date: string) => {
    setSelectedDate(date);
  }, []);

  const hideDetails = useCallback(() => {
    setSelectedDate(undefined);
    refetch();
  }, [setSelectedDate, refetch]);

  const detailItem: WorkingTimeTimeCardDayInfo | undefined = useMemo(() => {
    return timeCard?.timeCardDays?.find((x) => x.date === selectedDate);
  }, [timeCard?.timeCardDays, selectedDate]);

  return { showDetails, detailItem, hideDetails };
};
